import Hero from '../../components/Hero'
import './TechnologyDataCentres.css'

const TechnologyDataCentres = () => {
  return (
    <>
      <Hero 
        title="Technology & Data Centres"
        subtitle="Protecting sensitive equipment with specialist cleaning."
        backgroundImage="/sectors/technology/technology.png"
        height="55.78125vh"
      />
      
      <section>
        <div className="section-header">
          <h2>Sector Overview</h2>
        </div>
        <p>Data centres, server rooms and technology hubs house critical infrastructure that demands meticulous care. Dust, debris and static electricity can threaten uptime and reliability. Our technicians receive rigorous training in controlled environment cleaning and follow strict protocols to safeguard sensitive equipment while maintaining optimal operational conditions.</p>
        <div className="tech-grid">
          <article>
            <h3>Dust &amp; Contamination Control</h3>
            <p>Regular removal of dust and particulates from floors, racks, cable trays and equipment surfaces to prevent overheating and failures.</p>
          </article>
          <article>
            <h3>Static‑Safe Cleaning</h3>
            <p>Use of anti‑static tools and solutions to eliminate electrostatic discharge risk during cleaning activities.</p>
          </article>
          <article>
            <h3>Equipment &amp; Floor Care</h3>
            <p>Cleaning of raised flooring, server cabinets and sensitive components using specialised techniques and filtration systems.</p>
          </article>
          <article>
            <h3>Preventative Maintenance</h3>
            <p>Scheduled cleaning programs and environmental monitoring to reduce downtime and extend the lifespan of your assets.</p>
          </article>
        </div>
      </section>
      
      <section className="cta-section">
        <h2>Maintain System Integrity</h2>
        <p>Protect your critical infrastructure with specialist cleaning services designed for technology environments.</p>
        <a className="cta-button" href="/contact">Enquire Now</a>
      </section>
    </>
  )
}

export default TechnologyDataCentres
